import moment from 'moment';
import axios from 'axios';
import apiCryptography from '../utils/apiCryptography';
import * as APIRequest from '../utils/APIRequest';

async function Log(props) {
    let LogInput = {
        qRadar: {
            //correlationId: '0HLSV2D5CE80D:00000003',
            systemName: props.screen,
            activityDate: moment().format('MM/DD/YYYY hh:mm:ss a'),
            userId: props.refno.length > 15 ? props.refno.substring(0, 15) : props.refno,
            name: '',
            ipAddress: props.ipAdd,
            uri: props.url,
            screenModule: props.screen,
            activity: props.activity,
            changes: props.changes,
            details: props.details ? props.details.substring(0, 300) : 'NA',
        }
    };

    //console.log(LogInput);

    try {
        APIRequest.POST(
            `api/MW/Callapi`,
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    Accept: 'application/json',
                },
                APIurl: `${process.env.REACT_APP_API_LINK}/log`,
                APIdata: apiCryptography.encrypt(`{Data:{
                    qRadar: {
                    systemName: '${LogInput.qRadar.systemName}',
                    activityDate: '${LogInput.qRadar.activityDate}',
                    userId: '${LogInput.qRadar.userId}',
                    name: '${LogInput.qRadar.name}',
                    ipAddress: '${LogInput.qRadar.ipAddress}',
                    uri: '${LogInput.qRadar.uri}',
                    screenModule: '${LogInput.qRadar.screenModule}',
                    activity: '${LogInput.qRadar.activity}',
                    changes: '${LogInput.qRadar.changes}',
                    details: '${LogInput.qRadar.details}'         
                    }}}`),
                APImethod: 'POST',
                APIsystem: 'On-Boarding-Document-Upload',
                APIreferenceno: props.refno,
                APIevent: 'QRadar Log',
            },
        ).then((res) => {
            //console.log(res);
        });
    } catch (e) {
        console.log(e);
    }
}

async function ErrorLog(props) {
    let ErrorLogInput = {
        executionTime: moment().format('MM/DD/YYYY hh:mm:ss a'),
        executionDuration: 0,
        serviceName: props.serviceName,
        methodName: props.methodName,
        parameters: props.parameters,
        clientName: '',
        clientIpAddress: '',
        browser: '',
        exception: props.error,
        customData: props.parameters
    };

    //console.log(ErrorLogInput);

    //axios
    //  .post(process.env.REACT_APP_CORE_URL + '/Callapi', {
    //    APIurl: process.env.REACT_APP_API_URL + '/log/exception',
    //    APIdata: ErrorLogInput,
    //    APImethod: 'POST'
    //  })
    //  .then(response => {
    //    console.log(response);
    //  });
}


export { Log, ErrorLog };